var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81688 3.38025H6.93947C6.25835 3.38025 5.7063 2.82829 5.7063 2.14728C5.7063 1.46627 6.25835 0.914307 6.93947 0.914307H9.81688C10.498 0.914307 11.05 1.46627 11.05 2.14728C11.05 2.82829 10.498 3.38025 9.81688 3.38025Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95227 2.04907H3.94682C2.96783 2.04907 2.17419 2.84816 2.17419 3.83388V14.315C2.17419 15.3008 2.96783 16.0999 3.94682 16.0999H12.8078C13.7868 16.0999 14.5804 15.3008 14.5804 14.315V3.83388C14.5804 2.84816 13.7868 2.04907 12.8078 2.04907H10.7246",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93534 11.4174L5.25395 9.72942C5.01697 9.49152 5.01207 9.10831 5.24288 8.86442C5.48186 8.6119 5.88159 8.60479 6.12939 8.84865L6.27705 8.99396L7.34998 10.0647L10.6064 6.80828C10.8523 6.56239 11.2516 6.56465 11.4947 6.81331C11.7339 7.05793 11.7317 7.44939 11.49 7.69141L7.76707 11.418C7.53739 11.6479 7.16468 11.6476 6.93534 11.4174Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardOutline);
export default __webpack_public_path__ + "static/media/clipboard-outline.e282353034f50310a4bb316fcbce7a4f.svg";
export { ForwardRef as ReactComponent };